import { TYPES } from 'action-types/featureToggle';
import { IFeatureToggleModel } from 'reducers/featureToggle/models';
import * as msgs from '../../constants/validationMessages';

export interface IFeatureToggleAction {
    readonly type: string;
    readonly errors?: string | string[];
    readonly featureToggles: IFeatureToggleModel[];
}

export interface IFeatureToggleState {
    readonly isFetchDataLoading: boolean;
    readonly isFeatureDataReady: boolean;
    readonly isFetchDataError: boolean;
    readonly pendingError: string | string[];
    readonly featureToggles: IFeatureToggleModel[]
}

export const defaultState: IFeatureToggleState = {
    isFetchDataError: false,
    pendingError: '',
    isFetchDataLoading: false,
    isFeatureDataReady: false,
    featureToggles: []
};

export const reducer = (state: IFeatureToggleState = defaultState, action: IFeatureToggleAction): IFeatureToggleState => {
    switch (action.type) {
            case TYPES.FETCH_FEATURE_TOGGLES_DATA.PENDING:
                return {
                    ...state,
                    featureToggles: defaultState.featureToggles,
                    isFetchDataLoading: true,
                    isFetchDataError: false,
                    isFeatureDataReady: false,
                    pendingError: ''
                };
            case TYPES.FETCH_FEATURE_TOGGLES_DATA.FULFILLED:
                return {
                    ...state,
                    featureToggles: action.featureToggles,
                    isFetchDataLoading: false,
                    isFetchDataError: false,
                    isFeatureDataReady: true,
                    pendingError: action.featureToggles && action.featureToggles.length > 0 ? '' : msgs.ExtraDocument.Pending_Error
                };
            case TYPES.FETCH_FEATURE_TOGGLES_DATA.REJECTED:
                return {
                    ...state,
                    featureToggles: defaultState.featureToggles,
                    isFetchDataLoading: false,
                    isFetchDataError: true,
                    isFeatureDataReady: true,
                    pendingError: action.errors && action.errors.length ? action.errors.toString() : msgs.ExtraDocument.Error_Msg
                };
        default:
            return state;
    }
};
